export default "__VITE_ASSET__ERTT1CiA__"